import { Controller } from "@hotwired/stimulus"

// Executes reCAPTCHA v3 or renders v2 checkbox after api.js (layout, once per
// Turbo session) is ready. Avoids duplicate api.js loads from gem helpers.
export default class extends Controller {
  static values = {
    siteKey: String,
    action: { type: String, default: "register" },
    version: { type: String, default: "v3" }
  }

  connect() {
    this._runWhenReady(() => this._init())
  }

  disconnect() {
    if (this._poll) window.clearInterval(this._poll)
  }

  _runWhenReady(fn) {
    if (window.grecaptcha?.ready) {
      window.grecaptcha.ready(fn)
      return
    }

    this._poll = window.setInterval(() => {
      if (window.grecaptcha?.ready) {
        window.clearInterval(this._poll)
        this._poll = null
        window.grecaptcha.ready(fn)
      }
    }, 50)
  }

  _init() {
    if (this.versionValue === "v2") {
      this._renderV2()
    } else {
      this._executeV3()
    }
  }

  _renderV2() {
    const el = this.element.querySelector(".g-recaptcha") || this.element
    if (!window.grecaptcha?.render || el.childElementCount > 0) return

    const siteKey = this.siteKeyValue || el.dataset.sitekey
    if (!siteKey) return

    window.grecaptcha.render(el, { sitekey: siteKey })
  }

  _executeV3() {
    // Prefer direct execute: gem's executeRecaptchaForRegister (turbo + script:false)
    // may omit setInputWithRecaptchaResponseTokenForRegister.
    const input = this.element.querySelector("#g-recaptcha-response-data-register")
    const siteKey = this.siteKeyValue || input?.dataset?.sitekey
    if (!window.grecaptcha?.execute || !siteKey || !input) return

    window.grecaptcha.execute(siteKey, { action: this.actionValue }).then((token) => {
      if (input.isConnected) input.value = token
    })
  }
}
